import ReactDOM from 'react-dom/client';
import { retrieveLaunchParams } from '@telegram-apps/sdk-react';

import { init } from '@/init.tsx';
import { Root } from '@/components/Root';
import './index.css';
import './i18n';
import Page500 from '@/pages/CodeErrors/Page500.tsx';
import { PlatformUnsupported } from '@/components/PlatformUnsupported.tsx';
import { VersionUnsupported } from '@/components/VersionUnsupported.tsx';
import * as Sentry from '@sentry/react';
import { helpers } from '@/helpers.ts';
import { logEvent } from '@/utils/sentry-monitor.tsx';

const appEnv = helpers.getEnvVar('VITE_APP_ENV', 'dev');
const isSentryEnabled = ['prod', 'stage'].includes(appEnv);

if (isSentryEnabled) {
  Sentry.init({
    dsn: 'https://333792da5f3ac6961ee34902cfd13d92@o4509253376278528.ingest.de.sentry.io/4509253377720400',
    environment: appEnv,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

// Initialization of the token monitoring system
// monitorStorage();

const root = ReactDOM.createRoot(document.getElementById('root')!);

const isSupportedBotVersion = () => {
  const { tgWebAppVersion } = retrieveLaunchParams();

  return tgWebAppVersion && Number(tgWebAppVersion) >= 8;
};

const renderApp = async () => {
  try {
    const isDebug = helpers.getEnvVar('VITE_DEBUG', 'false') === 'true';

    await init(isDebug);

    const { tgWebAppPlatform } = retrieveLaunchParams();

    if (!['ios', 'android'].includes(tgWebAppPlatform)) {
      root.render(<PlatformUnsupported />);

      logEvent(
        `Open app from unsupported platform`,
        { platform: tgWebAppPlatform },
        'info',
        true
      );

      return;
    }

    if (!isSupportedBotVersion()) {
      root.render(<VersionUnsupported />);
      return;
    }

    root.render(<Root />);
  } catch (e) {
    Sentry.captureException(e, {
      extra: {
        context: 'Initializing the application'
      }
    });

    root.render(<Page500 />);
  }
};

void renderApp();
